module.exports = __webpack_public_path__ + "img/15.431c1b1d.png";